import { setAllEntities, setEntity, withEntities } from "@ngrx/signals/entities";
import { setFulfilled, withRequestStatus } from "../extensions/request-status.feature";
import { patchState, signalStore, type, withHooks, withMethods } from "@ngrx/signals";
import { BackOfficeOfferViewModel } from "@playcharge/common/models/backend/offers/backoffice/backoffice-offer-view-model";
import { ApiOffersService } from "../../services/api-offers.service";
import { inject } from "@angular/core";
import { pipe, switchMap, tap } from "rxjs";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { OfferType } from "@playcharge/common/models/backend/offers/offer-type";
import { withOffersMethods } from "../extensions/offers-methods.feature";

export type GamesStore = InstanceType<typeof GamesStore>;

export const GamesStore = signalStore(
    { providedIn: "root", protectedState: false },
    withEntities<BackOfficeOfferViewModel>(),
    withEntities({ entity: type<BackOfficeOfferViewModel>(), collection: "archived" }),
    withRequestStatus(),
    withOffersMethods(),
    withMethods((store, apiOffersService = inject(ApiOffersService)) => ({
        loadGames: rxMethod<void>(
            pipe(
                switchMap(() => {
                    return apiOffersService.getAll(OfferType.Game, false).pipe(
                        tap((offers) => {
                            patchState(store, setAllEntities(offers));
                            patchState(store, setFulfilled());
                        }),
                    );
                }),
            ),
        ),
        loadArchived: rxMethod<void>(
            pipe(
                switchMap(() => {
                    return apiOffersService.getAll(OfferType.Game, true).pipe(
                        tap((offers) => {
                            patchState(store, setAllEntities(offers, { collection: "archived" }));
                        }),
                    );
                }),
            ),
        ),
    })),
    withHooks({
        onInit({ loadGames, loadArchived }) {
            loadGames();
            loadArchived();
        },
    }),
);
